import { isStorageAvailable, StorageWrapper } from "utils/infrastructure/storage-util"

class ConnectionStatusAlertStorage {
    storage: StorageWrapper | undefined
    key: string

    constructor() {
        this.storage = isStorageAvailable ? new StorageWrapper(window.localStorage) : undefined
        this.key = "ConnectionStatusAlert"
    }

    get(bookingHash: string) {
        const data = this.storage?.getObject<Record<string, Record<string, boolean>>>(this.key)
        return data?.[bookingHash] || { isMyConnectionBadShow: true, isPeerConnectionBadShow: true }
    }

    updateStore(key: string, value: boolean, bookingHash: string) {
        this.storage?.storeObject(this.key, {
            [bookingHash]: {
                ...this.get(bookingHash),
                [key]: value,
            },
        })
    }
}

export const connectionStatusAlertStorage = new ConnectionStatusAlertStorage()
